import { render, staticRenderFns } from "./FirstSection.vue?vue&type=template&id=ed2b0398&scoped=true"
import script from "./FirstSection.vue?vue&type=script&lang=js"
export * from "./FirstSection.vue?vue&type=script&lang=js"
import style0 from "./FirstSection.vue?vue&type=style&index=0&id=ed2b0398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b0398",
  null
  
)

export default component.exports